import React, { Component } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { FormData, Status } from 'components/misc'

export default class AwardFileDetail extends Component {
  static propTypes = {
    data: PropTypes.object,
    modalId: PropTypes.string
  }

  static defaultProps = {
    isEditing: false
  }

  render() {
    const { data, modalId } = this.props

    return (
      <Modal id={modalId}>
        <div className="row">
          <div className="col-xs-12">
            <FormData label="Title" intlKey="label.title">
              {get(data, 'title') || '---'}
            </FormData>
          </div>
          <div className="col-xs-12">
            <FormData label="Description" intlKey="label.description">
              {get(data, 'description') || '---'}
            </FormData>
          </div>
          <div className="col-xs-12">
            <FormData label="Category" intlKey="label.category">
              {get(data, 'category.translationText') || '---'}
            </FormData>
          </div>
          <div className="col-xs-12">
            <FormData label="Section" intlKey="label.section">
              {get(data, 'section.translationText') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Author" intlKey="label.author">
              {get(data, 'author.firstName')} {get(data, 'author.lastName')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Created at" intlKey="label.created_at">
              {get(data, 'author.createdAt') && (
                <FormattedDate value={data.author.createdAt} />
              )}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Assessor report" intlKey="label.assessor_report">
              <Status
                state={get(data, 'isAssessorReportFile')}
                check
                noWaiting
                inline
              />
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Parental consent" intlKey="label.parental_consent">
              <Status
                state={get(data, 'isParentalConsentFile')}
                check
                noWaiting
                inline
              />
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Observation file" intlKey="table.observation_file">
              <Status
                  state={get(data, 'isObservationFile')}
                  check
                  noWaiting
                  inline
              />
            </FormData>
          </div>
        </div>
      </Modal>
    )
  }
}
